import React, { useEffect, useState, Suspense } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import './App.scss';

import Select from './Components/Select'
import e from './Utils/Event'

import Home from './Pages/Home'
import Enter from './Pages/Enter'
import EnterChoose from './Pages/EnterChoose';
import CheckIfRecorded from './Pages/CheckIfRecorded';
import GetSingerList from './Pages/GetSingerList';
import ChangeAccountInput from './Pages/ChangeAccountInput';
import Agreement from './Pages/Agreement';
import Guide from './Pages/Guide';
import RemixBackend from './Pages/RemixBackend'

import history from './History';
import openKugouApp from "@kugou/open-kugou-app"
import collect from './Utils/collect'
import apm from './Utils/collect/apm'
import LightMobileCall from '@kugou/light-mobilecall'
import kgStatObj from "@kugou/stat";
const { kgStatPush, notifyToStartReporting } = kgStatObj;

function App() {
  const [loading, setLoading] = useState(false)
  const [loadingText, setLoadingText] = useState('')

  const [ifOpenSelector, changeIfOpenSelector] = useState(false)
  const [selectorProp, setSelectorProp] = useState({})

  const [routeMap, setRouteMap] = useState([])

  function closeSelector() {
    changeIfOpenSelector(false)
  }

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) { return pair[1]; }
    }
    return false;
  }

  useEffect(() => {
    notifyToStartReporting()
    
    let baseMap = [
      { p: '/', c: Home },
      { p: '/enter/:info', c: Enter },
      { p: '/enter-choose', c: EnterChoose },
      { p: '/check-if-recorded', c: CheckIfRecorded },
      { p: '/get-singer-list/:name', c: GetSingerList },
      { p: '/agreement', c: Agreement },
      { p: '/ChangeAccountInput/:info', c: ChangeAccountInput },
      { p: '/guide', c: Guide },
      { p: '/remix-backend', c: RemixBackend }
    ]
    window.$getUserInfo(({ isLogin }) => {
      if (!isLogin) {
        setRouteMap(baseMap);
        if(getQueryVariable('toClient')){
          return openKugouApp("303", 9, 0, {
            url: window.location.href,
            title: document.title
          })
        }
        apm.indexLoadTime({ endTime: +new Date() })
        collect.reportResourceLoad();
      } else {
        window.$checkIfToResult((toEnter, status) => {
          let FaceAuBack = getQueryVariable('FaceAuBack');
          if( FaceAuBack ){
            console.log('FaceAuBack',FaceAuBack)
            let path = '/enter/' + FaceAuBack
            history.go(path)
          }

          if (toEnter) {
            baseMap.shift()
            setRouteMap(baseMap)
            apm.indexLoadTime({ endTime: +new Date() })
            collect.reportResourceLoad();
            return;
          }

          //去认领
          let toClaim = getQueryVariable('toClaim') || getQueryVariable('claimSinger')
          //去绑定
          let toBind = getQueryVariable('toBind')
          if (toClaim) {
            baseMap = [baseMap[2], baseMap[1], baseMap[4], baseMap[5]]
          }

          setRouteMap(baseMap)

          if (toClaim) {
            window.toClaim = true
            history.go('/enter-choose')
          }

          if (toBind) {
            window.toBind = true;
            let path = '/enter/' + window.encodeURIComponent(JSON.stringify({ status }))
            history.go(path)
          }
          //iOS#会截断兼容
          let ChangeAccountInput = getQueryVariable('ChangeAccountInput');
          if( ChangeAccountInput ){
            let path = '/ChangeAccountInput/' + ChangeAccountInput
            history.go(path)
          }

          apm.indexLoadTime({ endTime: +new Date() })
          collect.reportResourceLoad();
        })
      }
    })

    e.on('selector', props => {
      setSelectorProp(props)
      changeIfOpenSelector(true)
    })

    e.on('closeSelector', () => {
      changeIfOpenSelector(false)
    })
  }, []);

  return (<div className="App" id='APP'>
    <Router>
      <Suspense fallback={<div></div>}>
        <Switch>
          {routeMap.map(ele => (<Route key={ele.p} exact path={ele.p} component={ele.c}></Route>))}
        </Switch>
      </Suspense>
    </Router>
    {ifOpenSelector && <Select close={closeSelector} {...selectorProp} />}
  </div>);
}

export default App;
